import { createSelector } from '@reduxjs/toolkit';

import { GlobalState } from '@/redux/store';

const stateSelector = (state: GlobalState) => state;

export const getUiLogin = createSelector(stateSelector, (state) => state.login);
export const getLoginSubmitted = createSelector(getUiLogin, ({ submitted }) => submitted);
export const getHasLoginError = createSelector(getUiLogin, ({ error }) => error);
export const getHasLoggedIn = createSelector(getUiLogin, ({ success }) => success);

export const getRequiresTwoStepAuthenticationCode = createSelector(getUiLogin, (slice) => {
    return slice.requiresTwoStepAuthentication;
});

export const getObfuscatedPhoneNumber = createSelector(
    getUiLogin,
    ({ obfuscatedPhoneNumber }) => obfuscatedPhoneNumber
);
